module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Cheese-a54559719649c70d17c7bfa8f3fd44d0.svg";